'use strict';
const angular = require('angular');
require('angular-translate');
const moment = require('moment');

export default angular
  .module('nomasvelloDashboardApp.translator', ['pascalprecht.translate'])
  .config([
    '$translateProvider',
    /*ngInject*/
    function($translateProvider) {
      $translateProvider.translations('it', {
        BTN_ACCEPT: 'Accetta',
        BTN_ADD: 'Aggiungi',
        BTN_BACK: 'Indietro',
        BTN_CANCEL: 'Annulla',
        BTN_CONFIRM: 'Conferma',
        BTN_CREATE: 'Crea',
        BTN_DELETE: 'Elimina',
        BTN_EDIT: 'Modifica',
        BTN_DO_WITHDRAW: 'Ritira',
        BTN_UNDO_WITHDRAW: 'Annulla',
        BTN_LOGIN: 'Accedi',
        BTN_RESET: 'Resetta',
        BTN_SAVE: 'Salva',
        ERROR_400: 'Dati invalidi',
        ERROR_401: 'Autenticazione richiesta',
        ERROR_403: 'Permesso negato',
        ERROR_404: 'Risorsa non trovata',
        ERROR_405: 'Operazione non permessa',
        ERROR_406: 'Errore interno del server',
        ERROR_409: 'Conflitto nei dati',
        ERROR_500: 'Errore interno del server',
        ERROR_DUPLICATE_ENTRY: 'Dati Duplicati',
        ERROR_INCORRECT_PASSWORD: 'Errore password sbagliata',
        ERROR_MAIL_NOT_REGISTERED: 'Errore mail non registrata',
        ERROR_NAME_UNIQUE: 'Valore già in uso',
        ERROR_NO_DATES_FOR_SHOP: 'Nessun report per il negozio selezionato',
        ERROR_TOTAL_NOT_MATCH_CASH_INFO:
          'Il totale ricevute non coincide con le informazioni di cassa per: ',
        FORM_ERROR_INVALID_EMAIL: 'La mail inserita non è valida',
        FORM_ERROR_INVALID_PASSWORD:
          'La password deve essere almeno 3 caratteri',
        FORM_ERROR_PASSWORD_MISMATCH: 'Le password non coincidono',
        FORM_ERROR_REQUIRED: 'Parametro obbligatorio',
        LBL_ACTIVE: 'Attivo',
        LBL_ADMIN: 'Amministratore',
        LBL_ALREADY_PAID: 'Già pagato',
        LBL_ASSISTANT: 'Assistente',
        LBL_ASSISTANTS: 'Assistenti',
        LBL_AVAILABLE_OFFERS: 'Offerte',
        LBL_AVAILABLEOFFERS: 'Offerte disponibili',
        LBL_BILLS: 'Banconote',
        LBL_CABIN_1_PULSE: 'Impulsi manipolo cabina IPL',
        LBL_CABIN_2_PULSE: 'Impulsi manipolo cabina Laser',
        LBL_CABIN_3_PULSE: 'Impulsi manipolo cabina Proskin',
        LBL_CABIN_4_PULSE: 'Impulsi manipolo cabina Laser + Proskin',
        LBL_CABIN_PULSE_1_COST: 'Costo impulsi IPL',
        LBL_CABIN_PULSE_1_DIFFERENCE: 'Differenza impulsi IPL',
        LBL_CABIN_PULSE_1_END: 'Impulsi fine giornata cabina IPL',
        LBL_CABIN_PULSE_1_START: 'Impulsi inizio giornata cabina IPL',
        LBL_CABIN_PULSE_2_COST: 'Costo impulsi Laser',
        LBL_CABIN_PULSE_2_DIFFERENCE: 'Differenza impulsi IPL',
        LBL_CABIN_PULSE_2_END: 'Impulsi fine giornata cabina Laser',
        LBL_CABIN_PULSE_2_START: 'Impulsi inizio giornata cabina Laser',
        LBL_CABIN_PULSE_3_COST: 'Costo impulsi Proskin',
        LBL_CABIN_PULSE_3_DIFFERENCE: 'Differenza impulsi LASER',
        LBL_CABIN_PULSE_3_END: 'Impulsi fine giornata cabina Proskin',
        LBL_CABIN_PULSE_3_START: 'Impulsi inizio giornata cabina Proskin',
        LBL_CABIN_PULSE_4_COST: 'Costo impulsi Laser + Proskin',
        LBL_CABIN_PULSE_4_DIFFERENCE: 'Differenza impulsi LASER',
        LBL_CABIN_PULSE_4_END: 'Impulsi fine giornata cabina Laser + Proskin',
        LBL_CABIN_PULSE_4_START:
          'Impulsi inizio giornata cabina Laser + Proskin',
        LBL_CABIN_PULSES: 'Impulsi manipolo cabine',
        LBL_CABINS: 'Cabine disponibili',
        LBL_CASH_DESK_REPORT_TITLE: 'VENDITE',
        LBL_CASH_DESK_TOTAL: 'Fondo cassa Totale',
        LBL_CASH_DESK: 'Informazioni di cassa',
        LBL_CASH_MONEY_END_OF_DAY: 'Fondo cassa fine giornata',
        LBL_CASH_MONEY_TOTAL: 'Totale contanti',
        LBL_CASH_TOTAL: 'Totale cassa',
        LBL_CHANGE_PASSWORD: 'Cambio password',
        LBL_COINS: 'Spiccioli',
        LBL_CONFIGURATIONS: 'Configurazioni',
        LBL_CONFIRM_PASSWORD: 'Conferma la nuova password',
        LBL_DAILY_REPORT: 'Report giornaliero',
        LBL_DATA_SAVED: 'Dati salvati',
        LBL_DATA_SAVING: 'Salvataggio dati in corso',
        LBL_DATE_SELECTION: 'Seleziona un mese',
        LBL_DAY: 'Giorno',
        LBL_DELETE: 'Elimina',
        LBL_DEPOSIT: 'Versato',
        LBL_DISCOUNT: 'Sconto',
        LBL_EMAIL: 'Email',
        LBL_ERROR_FIELD_NOT_VALID: 'Campo non valido',
        LBL_ERROR_FIELD_REQUIRED: 'Campo obbligatorio',
        LBL_FILE_MONTHLY_CASH_DESK:
          'JS Registro di cassa mensile (monthly-cash-desk)',
        LBL_FILE_MONTHLY_SELLING: 'JS Report mensile vendita (monthly-selling)',
        LBL_FIRST_NEW_ASSISTANT: 'Inserisci i dati del primo/a assistente',
        LBL_FIRST_NEW_CONFIGURATION: 'Nuova configurazione',
        LBL_FIRST_NEW_OFFER: 'Inserisci i dati della prima offerta',
        LBL_FIRST_NEW_PRODUCT: 'Inserisci i dati del primo prodotto',
        LBL_FIRST_NEW_SERVICE: 'Inserisci i dati del primo trattamento',
        LBL_FIRST_NEW_SHOP: 'Inserisci i dati del primo negozio',
        LBL_FOOTER_TITLE: 'Mediaestetica Dashboard',
        LBL_HAS_CABIN_1: 'Cabina IPL',
        LBL_HAS_CABIN_2: 'Cabina Laser',
        LBL_HAS_CABIN_3: 'Cabina Proskin',
        LBL_HAS_CABIN_4: 'Cabina Laser + Proskin',
        LBL_HIDE: 'Nascondi',
        LBL_INFO: 'Informazioni',
        LBL_INFORMATIONS_ONLY: 'Solo info',
        LBL_IS_IPL: 'Trattamento IPL',
        LBL_IS_PROSKIN: 'Trattamento Proskin',
        LBL_LIST: 'Lista elementi',
        LBL_LOGIN: 'Login',
        LBL_MANAGER: 'Manager',
        LBL_MONTHLY_CASH_DESK: 'Registro di cassa mensile',
        LBL_MONTHLY_SELLING_PRODUCTS: 'PRODOTTI VENDUTI',
        LBL_MONTHLY_SELLING_SERVICES: 'CLIENTI IN AGENDA',
        LBL_MONTHLY_SELLING: 'Report mensile vendita',
        LBL_NAME: 'Nome',
        LBL_NEW_ASSISTANT: "Inserisci i dati dell'assistente",
        LBL_NEW_CLIENTS_INFO: 'Nuovi clienti telefonate e passaggio',
        LBL_NEW_CLIENTS_REPORT_TITLE: 'NUOVI CLIENTI',
        LBL_NEW_CLIENTS: 'NUOVI CLIENTI',
        LBL_NEW_DATA: 'Inserisci i dati',
        LBL_NEW_PASSWORD: 'Nuova password',
        LBL_NEW: 'Aggiungi nuovo',
        LBL_NO_ASSISTANTS_FOUND: 'Nessun assistente trovato/a',
        LBL_NO_DATA_AVAILABLE: 'Nessun dato disponibile',
        LBL_NO_DATA_FOUND: 'Nessun dato presente',
        LBL_NO_PRODUCTS_FOUND: 'Nessun prodotto trovato',
        LBL_NO_SHOPS_AVAILABLE:
          'Tutti gli utenti sono stati abbinati ai relativi negozi',
        LBL_NOTE: 'Note',
        LBL_O: 'O',
        LBL_OFFERS: 'Lista offerte',
        LBL_OLD_PASSWORD: 'Vecchia password',
        LBL_OTHER_NOTE: 'Altre note',
        LBL_OTHER: 'Altro',
        LBL_OTHERS: 'Altro',
        LBL_PASSWORD: 'Password',
        LBL_POS_TOTAL: 'Totale POS',
        LBL_PREVIEW: 'Anteprima',
        LBL_PRICE: 'Prezzo',
        LBL_PRODUCTS: 'Lista Prodotti',
        LBL_PROSKIN: 'Proskin',
        LBL_PULSES_REPORT_TITLE: 'IMPULSI',
        LBL_PULSES: 'IMPULSI',
        LBL_RECEIPT_TOTAL: 'Ricevute Totale',
        LBL_REPORT_QUANTITY: 'Quantità',
        LBL_REPORT_REVIEW: 'Revisione report',
        LBL_REPORT_SELECTION: 'Seleziona un report',
        LBL_REPORT_SERVICE_OFFER: 'Offerte sui trattamenti',
        LBL_REPORT_SERVICE: 'Trattamento',
        LBL_REPORT_SERVICES: 'Trattamenti effettuati',
        LBL_RESET: 'Resetta',
        LBL_ROLE: 'Ruolo',
        LBL_SCHEDULED_TESTS: 'Prove fissate',
        LBL_SEARCH: 'Cerca',
        LBL_SERVICES: 'Lista trattamenti',
        LBL_SESSIONS: 'Sedute',
        LBL_SHOP_CABINS_HELP:
          "Abilita nel report giornaliero l'inserimento del numero di impulsi per ogni cabina selezionata.",
        LBL_SHOP_SELECTION: 'Scegli un negozio',
        LBL_SHOP: 'Negozio',
        LBL_SHOPS: 'Lista Negozi',
        LBL_SHOW: 'Mostra',
        LBL_SIGNUP: 'Crea nuovo utente',
        LBL_SOLD_PRODUCTS: 'Prodotti venduti',
        LBL_TODAY_TOTAL: 'Totale ricevute',
        LBL_TOTAL_EARNINGS: 'Totale ricavi',
        LBL_TOTAL_POS: 'Totale POS',
        LBL_START_CASH: 'Fondo cassa iniziale',
        LBL_NOT_PRESENT: 'N/A',
        LBL_DATA_CHANGED: 'Da salvare',
        LBL_TOTAL: 'Totale',
        LBL_TOTALS_REPORT_TITLE: 'Report totali mensili del',
        LBL_TOTALS_REPORT: 'Report totali mensili',
        LBL_USER_MANAGEMENT: 'Gestione utenti',
        LBL_USER_WELCOME: 'Ciao',
        LBL_USER: 'Utente',
        LBL_USERS_LIST: 'Lista client',
        LBL_VIEWER: 'Visualizzatore',
        MENU_ADMIN: 'Gestione Client',
        MENU_HOME: 'Home',
        NAVBAR_ADMIN: 'Sezione amministratore',
        NAVBAR_ASSISTANTS: 'Assistenti',
        NAVBAR_CONFIGURATIONS: 'Configurazioni',
        NAVBAR_DAILY_REPORT_REVIEW: 'Report giornalieri',
        NAVBAR_DAILY_REPORT: 'Report giornaliero',
        NAVBAR_HOME: 'Mediaestetica Dashboard',
        NAVBAR_LOCALE: 'Lingua',
        NAVBAR_LOGOUT: 'Logout',
        NAVBAR_MANAGER: 'Sezione manager',
        NAVBAR_MONTHLY_CASH_DESK: 'Registro di cassa mensile',
        NAVBAR_MONTHLY_SELLING: 'Report mensile vendita',
        NAVBAR_OFFERS: 'Offerte',
        NAVBAR_PRODUCTS: 'Prodotti',
        NAVBAR_SERVICES: 'Trattamenti',
        NAVBAR_VIEWER: 'Sezione visualizzatore',
        LBL_INFO_PASSWORD_CHANGED: 'Password cambiata correttamente',
        NAVBAR_SETTINGS: 'Cambio password',
        NAVBAR_SHOPS: 'Negozi',
        NAVBAR_SIGNUP: 'Registra utente',
        NAVBAR_TOTALS_REPORT: 'Report totali mensili',
        NAVBAR_USER_MANAGEMENT: 'Gestione utenti',
        NAVBAR_USER: 'Ciao $user',
        NO_DATA_AVAILABLE: 'Nessun dato disponibile',
        TABLE_HEADING_ACTION: 'Azione',
        TABLE_HEADING_DETAILS: 'Dettagli',
        TABLE_HEADING_NAME: 'Nome',
        TITLE_LIST: 'Lista',
        TITLE_USER_SETTINGS: 'Cambia password'
      });

      $translateProvider.registerAvailableLanguageKeys(['it', 'it'], {
        en_US: 'it',
        en_UK: 'it',
        en_GB: 'it',
        it_IT: 'it'
      });
      $translateProvider.preferredLanguage('it');
      moment.locale('it');
      // $translateProvider.determinePreferredLanguage();
    }
  ]).name;



// WEBPACK FOOTER //
// ./client/components/i18n/translator.ts